{
  "nav": {
    "home": "Home",
    "project": "Project",
    "science": "Science",
    "team": "Team",
    "updates": "Updates",
    "getInvolved": "Join"
  },
  "footer": {
    "tagline": "AquaWorks site located on UBC's Vancouver campus",
    "description": "AquaWorks is a student-led engineering project developed by students at the University of British Columbia, building a radar-assisted water-quality monitoring robot.",
    "quickLinks": "Explore",
    "copyright": "© {{year}} AquaWorks."
  },
  "common": {
    "placeholder": "Content coming soon.",
    "backToHome": "Back to Home",
    "source": "Source",
    "planned": "Planned",
    "notCertification": "Student prototype. Not professional monitoring or water-safety certification."
  },
  "memberCard": {
    "program": "Program",
    "focus": "Focus"
  },
  "languageSwitcher": {
    "chinese": "中文",
    "english": "English",
    "french": "Français",
    "ariaLabel": "Switch language"
  },
  "sourceDocuments": {
    "spf": "AMS Sustainability Projects Fund application",
    "timeline": "AquaWorks Phase 1 timeline",
    "ismp": "Integrated Stormwater Management Plan (Vancouver campus)",
    "seeds": "SEEDS rain-garden and green rainwater infrastructure reports"
  }
}
